module.exports = __webpack_public_path__ + "img/contacts.2c1140b7.svg";